import nipplejs from "nipplejs"
import { DataArray } from "src/common/DataArray"
import { Event, GameMessage, createControllerMessage, createGameMessage } from "src/common/networkingHelper"
import { WebSocketManager } from "./WebSocketManager"
import { PlayerId, PlayerImages } from "$types/index"
import { playerIcons } from "src/common/Player"

function startManager(ws: WebSocketManager, zone: HTMLElement, messageBuffer: DataArray) {
  let follow = true
  try {
    const urlSearchParams = new URLSearchParams(window.location.search)
    if (urlSearchParams.has("branka")) {
      follow = false // ask cesco lol
    }
  } catch {
    //
  }

  const manager = nipplejs.create({
    zone,
    color: "#dbd1c7",
    size: Math.min(Math.max(Math.min(window.innerWidth, window.innerHeight), 300), 500) * 0.5,
    restOpacity: 1,
    mode: "static",
    position: { top: "50%", left: "50%" },
    maxNumberOfNipples: 1,
    follow,
    dynamicPage: true,
  })

  const lastDirectionInputDataArray = new DataArray(new ArrayBuffer(1))
  const sendDirectionIfChanged = (direction: number) => {
    if (lastDirectionInputDataArray.getUint8(0) !== direction) {
      lastDirectionInputDataArray.setUint8(0, direction)
      ws.send(createControllerMessage(direction, messageBuffer).buffer)
    }
  }

  manager.on("move", function (_evt, data) {
    const direction = data.direction ? data.direction.angle : "undefined"
    switch (direction) {
      case "up":
        sendDirectionIfChanged(Event.MOVE_UP)
        break
      case "down":
        sendDirectionIfChanged(Event.MOVE_DOWN)
        break
      case "left":
        sendDirectionIfChanged(Event.MOVE_LEFT)
        break
      case "right":
        sendDirectionIfChanged(Event.MOVE_RIGHT)
        break
      default:
        sendDirectionIfChanged(Event.MOVE_STOP)
        break
    }
  })

  manager.on("end", function () {
    sendDirectionIfChanged(Event.MOVE_STOP)
  })

  return manager
}

export function initController(playerId: PlayerId, ws: WebSocketManager, images: PlayerImages): void {
  document.body.addEventListener("pointerdown", () => {
    window.requestFullScreen()
  })

  const messageBuffer = new DataArray(new ArrayBuffer(1))

  const buttonAZone = document.getElementById("button-a-zone")
  const buttonA = document.getElementById("buttonA")
  const buttonBZone = document.getElementById("button-b-zone")
  const buttonB = document.getElementById("buttonB")
  const playerImage = document.getElementById("controller_player_img") as HTMLImageElement

  const zone = document.getElementById("zone_joystick")!
  let manager = startManager(ws, zone, messageBuffer)
  window.addEventListener("resize", () => {
    manager.destroy()
    manager = startManager(ws, zone, messageBuffer)
  })

  const onButtonClick = (button: HTMLElement, timeoutId: number) => {
    try {
      navigator.vibrate(50)
    } catch (e) {
      console.warn(e)
    }
    clearTimeout(timeoutId)
    button.classList.add("pressed")
    timeoutId = window.setTimeout(() => {
      button.classList.remove("pressed")
    }, 100)
  }

  if (buttonAZone && buttonA) {
    let timeoutIdA: number
    buttonAZone.addEventListener("pointerdown", () => {
      onButtonClick(buttonA, timeoutIdA)
      ws.send(createControllerMessage(Event.ACTION_A_DOWN, messageBuffer).buffer)
    })
  }

  if (buttonBZone && buttonB) {
    let timeoutIdB: number
    buttonBZone.addEventListener("pointerdown", () => {
      onButtonClick(buttonB, timeoutIdB)
      ws.send(createControllerMessage(Event.ACTION_B_DOWN, messageBuffer).buffer)
    })
  }

  console.log(images)

  ws.onmessage.push(({ data }) => {
    if (data.length > 1) {
      const message: GameMessage = JSON.parse(data)
      switch (message.type) {
        case "REDIRECT_TO_WITHDRAW": {
          const urlSearchParams = new URLSearchParams(window.location.search)
          const newUrl = new URL(window.location.href)
          newUrl.pathname = "/withdraw"
          void ["userId", "gameId"].forEach((key) => {
            const value = urlSearchParams.get(key)
            if (value) {
              newUrl.searchParams.set(key, value)
            }
          })
          ws.send(createGameMessage({ type: "REDIRECTED_TO_WITHDRAW" }))
          window.location.href = newUrl.href
          break
        }
        case "CONTROLLER_CONNECTED": {
          if (message.playerId !== playerId) {
            playerImage.src = images[playerIcons[message.playerId]]
          }
          break
        }
      }
    }
  })
}
